import { sharedColors } from "ui/theme/colors"

const colors = {
  ...sharedColors,
  propBlue: "white",
  heroBackgroundEn: "#fff",
  heroBackgroundHe: "#fff",
  heroTextColor: "#000",
  heroSvgIconColor: "#ffde00",
  filterModalHeaderColor: "rgba(255, 222, 0, 0.05)",
  filterModalHeaderTextColor: "#000",
  footerColor: "#000",
  socialColor: "#000",
  navBackgroundColor: "black",
  navTextColor: "white",
  selectedNavTextColor: "white",
  selectedSubNavTextColor: "white",
  selectedMobileNavTextColor: "black",
  footerSocialsBackgroundColor: "#FFDE00",
  footerLogoLinkBackgroundColor: "white",
  numberGridBackgroundColorEn: "linear-gradient(90deg, #FFDE00 0%, #CDB302 100%)",
  numberGridBackgroundColorHe: "linear-gradient(90deg, #CDB302 0%, #FFDE00 100%)",
  numberGridBorderColor: "rgba(255, 222, 0, 1)",
  numberGridTextColor: "black",
  newNumberGridTextColor: "black",
  accordionPanelBackgroundColor: "rgba(255, 222, 0, 0.4)",
  jobsQuoteGalleryBackgroundColor: "black",
  teamContainerBackgroundColor: "black",
  buttonHoverBackgroundColor: "black",
  buttonActiveBackgroundColor: "black",
  buttonHoverTextColor: "#FFDE00",
  paginationBackgroundColor: "black",
  paginationTextColor: "#FFDE00",
  bulletsBackgoundColor: "#FFDE00",
  faqTextColorExpanded: "white",
  faqTextColorHover: "white",
  faqRootBackground: "black",
  faqRootInsideBackground: "white",
  faqRootInsideBackgroundHover: "white",
  faqRootInsideColorHover: "black",
  faqBorderColor: "black",
  faqTextColor: "white",
  faqIconColor: "black",
  faqIconColorAlternative: "white",
  faqBoxShadow: "0px 4px 12px 0px rgba(0, 0, 0, 0.08)",
  faqTitleBorderBottom: "#FFDE00",
  jobCardTopHeader: "#000",
  heroBgFallback: "#000",
}

export default colors
